export default __webpack_public_path__ + "static/media/icon-latte-biscotti.698d73a6.svg";